
import Icon from "@/components/UI/Icon.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { TreeNode } from "@/types/tree";
import { rewriteContentInSection } from "@/subapps/onboarding/lib/ai";
import { logEvent } from "@/util/tracking";

@Component({
  components: {
    Icon
  }
})
export default class NodeOnboardinAIRewriteButton extends Vue {
  rewriteInProgress = false;

  @Prop()
  element!: TreeNode;

  async rewrite() {
    if (this.rewriteInProgress) return;
    if (!this.element) return;

    this.rewriteInProgress = true;

    logEvent("Onboarding", {
      action: "onboarding_app_ui_interaction",
      type: "node_rewrite_button"
    });

    try {
      await rewriteContentInSection(this.element.id);
    } catch (error) {
      console.error("Error during rewrite:", error);
    }

    this.rewriteInProgress = false;
  }
}
